export default "__VITE_ASSET__DVe5y8bB__"